import Vue from 'vue'
import VuetifyToast from 'vuetify-toast-snackbar'
import Vuetify from 'vuetify'
import '@/theme/default.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#5a459c',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    brand_neutral: '#414042',
    brand_primary: '#5a459c'
  },
  customProperties: true,
  iconfont: 'md'
})

Vue.use(VuetifyToast, {
  x: 'right', // default
  y: 'bottom', // default
  color: 'primary', // default
  icon: 'info',
  iconColor: '', // default
  classes: [
    'body-2'
  ],
  timeout: 3000, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: true, // default
  showClose: true, // default
  closeText: '', // default
  closeColor: '', // default
  shorts: {
    info: {
      color: 'info',
      icon: 'info'
    },
    error: {
      color: 'error',
      icon: 'error'
    }
  },
  property: '$toast' // default
})
